import styled from "styled-components";
import { fontFamilies } from "components/shared/tokens/typography";

const COLORS = {
  text: "#293142",
  border: "#e6e9ef",
};

export const Overlay = styled.div`
  position: fixed;
  inset: 0;
  z-index: ${(props) => props.$layer || 1000};
  background: rgba(0, 0, 0, 0.64);
  backdrop-filter: blur(8px);
`;

export const DrawerPanel = styled.aside`
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  z-index: ${(props) => (props.$layer || 1000) + 1};
  display: flex;
  width: 460px;
  max-width: 100vw;
  flex-direction: column;
  background: #ffffff;
  box-shadow: -4px 4px 31px rgba(0, 0, 0, 0.12);
`;

export const DrawerHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  border-bottom: 1px solid ${COLORS.border};
  padding: 24px;
  color: ${COLORS.text};
  font-family: ${fontFamilies.semiBold};
  font-size: 18px;
  line-height: 24px;
`;

export const DrawerTitleGroup = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  min-width: 0;
`;

export const DrawerIconButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 36px;
  height: 36px;
  padding: 0;
  border: 1px solid ${COLORS.border};
  border-radius: 50%;
  background: #ffffff;
  color: ${COLORS.text};
  cursor: pointer;
`;

export const DrawerClose = styled.button`
  display: inline-flex;
  border: 0;
  padding: 0;
  background: none;
  color: ${COLORS.text};
  cursor: pointer;
`;

export const DrawerBody = styled.div`
  min-height: 0;
  flex: 1;
  ${(props) => (props.$scrollable ? "overflow-y: auto;" : "")}
`;

export const DrawerFooter = styled.div`
  flex-shrink: 0;
  padding: 16px;
  background: #ffffff;
`;

export const FloatingCloseButton = styled.button`
  position: fixed;
  top: 16px;
  right: calc(460px + 12px);
  z-index: ${(props) => (props.$layer || 1000) + 1};
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  padding: 0;
  border: 0;
  border-radius: 50%;
  background: #ffffff;
  color: ${COLORS.text};
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.16);
  cursor: pointer;

  @media (max-width: 520px) {
    display: none;
  }
`;
